<template>
  <div class="auth-container">即将跳转企业微信授权页面...</div>
</template>

<script setup>
import { showDialog } from "vant";
import { onMounted, nextTick } from "vue";
import { isWeCom, buildWeComUserinfoAuthUrl } from "@/utils/wecomcon";

// 检查是否登录
onMounted(async () => {
  console.log("登录");

  // -------- 测试功能 --------------- S
  let localStorageData = {
    userInfo: {
      userid: "18326559058Zlp",
      mobile: "18326559058",
      gender: "1",
      avatar:
        "https://wework.qpic.cn/wwpic3az/644762_Og8qYHBrS5K8Vqd_1773042287/0",
    },
    vConsole_switch_x: 0,
    vConsole_switch_y: 20,
    weComUserInfo: {
      id: 8,
      created_at: "2026-03-09 15:48:47",
      updated_at: "2026-03-09 15:51:10",
      uuid: "818752160123854848",
      firm_uuid: 6,
      session_key: "",
      openid: "",
      phone: "18326559058",
      avatar_url:
        "https://wework.qpic.cn/wwpic3az/644762_Og8qYHBrS5K8Vqd_1773042287/0",
      nick_name: "ZCC",
      union_id: "",
      status: 1,
      shop_clerk_uuid: "789069110796623872",
      user_id: "18326559058Zlp",
      qr_code:
        "https://open.work.weixin.qq.com/wwopen/userQRCode?vcode=vcb3d5eddaa1c85a9f",
      address: "",
      gender: 1,
      shop_clerk_info: {
        id: 11,
        created_at: "2025-12-17 17:58:56",
        updated_at: "2025-12-18 16:28:43",
        uuid: "789069110796623872",
        firm_uuid: 6,
        phone: "18326559058",
        name: "ZCC",
        status: 1,
        is_admin: 1,
        admin: null,
        wx_shop_info: null,
        shop_clerk_positions: null,
        is_anchor: 1,
      },
    },
    departmentdata: {
      department_uuid: 1319170622,
      department_name: "华东市场",
      position_name: "运营",
    },
    token:
      "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJrZXkiOiI4MTg3NTIxNjAxMjM4NTQ4NDgiLCJzdWIiOiJ1c2VyIiwiZXhwIjoxNzczMzk0MzQ4LCJpYXQiOjE3NzMzNjU1NDh9.8avc12EbgYLsr6Ts3aiuSOA_4ZxeOuAJ64Ztwo3wIzg",
    shop_clerk_uuid: "789069110796623872",
  };
  Object.keys(localStorageData).forEach((v) => {
    let target = localStorageData[v];
    if (typeof target === "object") {
      target = JSON.stringify(target);
    }
    localStorage.setItem(v, target);
  });
  // -------- 测试功能 --------------- E

  // 等待页面真正渲染完成
  await nextTick();
  // 再异步执行弹框，确保不阻塞
  setTimeout(() => {
    if (!isWeCom()) {
      showDialog({
        message: "请在企业微信中打开此页面",
        theme: "round-button",
        confirmButtonColor: "#DCBB89",
      }).then(() => {});
      return;
    }

    // 企业微信环境 → 构造授权链接并跳转
    const { protocol, host } = window.location;
    const redirectUrl = `${protocol}//${host}/callback`;

    const authUrl = buildWeComUserinfoAuthUrl({
      redirectUrl,
    });

    window.location.href = authUrl;
  }, 0);
});
</script>

<style scoped>
.auth-container {
  text-align: center;
  padding: 20px;
  font-size: 20px;
  font-weight: 500;
  color: #654317;
  font-family: "PingFang SC-Semibold";
}
</style>
